import React from 'react';
import StTextField from '../misc/textField';
import StButton from "../misc/button";
import { compose } from 'recompose';
import { withRouter, Redirect } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import './index.css'

const SignInPage = () => (
    <div>
        <SignInForm />
    </div>
);

const INITIAL_STATE = { email: '', password: '' };

class SignInFormBase extends React.Component {

    constructor(props) {
        super(props);
        this.state = INITIAL_STATE;

        this.handleLogin = this.handleLogin.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this)
        this.onPasswordChange = this.onPasswordChange.bind(this)
    }

    handleLogin() {
        console.log(this.state)
        this.props.firebase
            .doSignInWithEmailAndPassword(this.state.email, this.state.password)
            .then(() => {
                this.setState({ ...INITIAL_STATE });
                this.props.history.push(ROUTES.HOME);
            })
            .catch(error => {
                //alert(error);
                this.setState({ error: error.toString() });
            });

    }

    onEmailChange(newString) {
        this.setState(state => ({
            email: newString
        }));
    }

    onPasswordChange(newString) {
        this.setState(state => ({
            password: newString
        }));
    }

    render() {
        if (this.props.firebase.auth.currentUser != null) {
            return <Redirect to={ROUTES.HOME} />;
        }
        return (
            <div className="App">
                <header className="App-header">
                    <div className="banner">
                        <img alt="" src={require('./../../assets/stBanner.png')} className="bannerImage" />
                        <div className="bannerText" > builder </div>
                    </div>
                    <form >
                        <StTextField id="login" label="Email" onChange={this.onEmailChange} />
                        <br />
                        <br />
                        <StTextField id="password" type="password" label="Password" onChange={this.onPasswordChange} />
                        <br />
                        <br />
                        { (this.state.error) ? <h5 className="error" style={{color: '#f00', backgroundColor: 'yellow'}} >{this.state.error}</h5> : '' }
                        <StButton onClick={this.handleLogin} text="Login" ></StButton>
                        <br />
                        <br />
                    </form>
                    {/* <br />
                        Don't have an account?
                    <br />
                    <br />

                    <StButton href={ROUTES.SIGN_UP} text="Sign up" ></StButton> */}
                </header>
            </div>

        );
    }
}

const SignInForm = compose(
    withRouter,
    withFirebase,
)(SignInFormBase);

export default SignInPage;
export { SignInForm };